import request from "./request"

export const getSupportTickets = params => request({ url: "/support/list_get", method: "get", params })
export const getSupportTicket = params => request({ url: "/support/detail_get", method: "get", params })
export const createSupportTicket = data => request({ url: "/support/create", method: "post", data })
export const replySupportTicket = data => request({ url: "/support/reply", method: "post", data })
export const getSupportAttachment = id => request({ url: "/support/attachment_get", method: "get", params: { id }, responseType: "blob", silentError: true })

export function uploadSupportAttachment(ticketId, messageId, file, onProgress) {
  const data = new FormData()
  data.append("ticket_id", ticketId)
  data.append("message_id", messageId)
  data.append("file", file)
  return request({
    url: "/support/attachment_upload",
    method: "post",
    data,
    timeout: 120000,
    onUploadProgress: event => {
      if (onProgress && event.total) onProgress(Math.min(100, Math.round(event.loaded / event.total * 100)))
    }
  })
}
